/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationRequestDetailResponseDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationRequestDetailResponseDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_TaxDetailRequestDataFromParticipantDetail } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_TaxDetailRequestDataFromParticipantDetail';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReleaseTaxCalculationService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationRequestDetailResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseTaxCalculationCalculateTax(
requestBody?: Array<Wealthlane_AwardService_Dtos_ParticipantTask_TaxDetailRequestDataFromParticipantDetail>,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_TaxCalculationRequestDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release-tax-calculation/calculate-tax',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
